import $ from 'jquery';
import moment from 'moment';
import store from 'store';

/**
 * Class representing Journey Tracking.
 */
export default class JourneyTracking {
	/**
	 * Construct a new JourneyTracking instance.
	 */
	constructor() {
		this.store = store;
		this.duration = 60 * 24 * 7; // One week (in minutes).
		this.keyPage = 'journeyPages';
		this.keyExpires = 'journeyExpires';

		this.init();
	}

	/**
	 * Init
	 *
	 * Initialize journey tracking and add the current page.
	 */
	init() {
		const suntraxSettings = window.suntraxSettings || {};

		this.resetIfExpired();
		if (suntraxSettings.postId) {
			this.addPage(suntraxSettings.postId, window.location.pathname);
		}
		this.preFillHiddenFields();
	}

	/**
	 * Add page
	 *
	 * Add page to journey.
	 *
	 * @param {string} postId Post ID.
	 * @param {string} path Page path.
	 */
	addPage(postId, path) {
		if (!postId) {
			throw new Error('Post ID is required.');
		}
		if (!path) {
			throw new Error('Page/path is required.');
		}

		const pages = this.store.get(this.keyPage) || {};
		// Adding a space so javascript does not automatically sort the object
		// since it uses numeric keys.
		pages[' ' + postId] = path;
		this.store.set(this.keyPage, pages);
	}

	/**
	 * Pre-fill Hidden Fields
	 *
	 * Pre-fill in journey tracking hidden fields.
	 */
	preFillHiddenFields() {
		const pages = this.store.get(this.keyPage);
		const formattedPages = [];

		for (const page in pages) {
			formattedPages.push({
				post_id: page.trim(),
				path: pages[page],
			});
		}

		var formattedPages2Str = "";

		for (var i=0; i<formattedPages.length; i++) {
			formattedPages2Str += (i+1) + ". " + formattedPages[i]['path']+ ",      ";
		}

		$('[value="journey_tracking"]').val(JSON.stringify(formattedPages));
		$('[value="formatted_journey_tracking"]').val(formattedPages2Str);
	}

	/**
	 * Reset if Expired
	 *
	 * Reset the journey if the expiration time has passed.
	 */
	resetIfExpired() {
		const oldExpire = this.store.get(this.keyExpires);

		// Check and reset if the journey has expired or hasn't been created yet.
		if (!oldExpire || moment().diff(oldExpire) > 0) {
			this.resetJourney();
		}
	}

	/**
	 * Reset Journey
	 *
	 * Reset the journey storage.
	 */
	resetJourney() {
		const expires = moment().add(this.duration, 'm').toDate();
		this.store.set(this.keyExpires, expires);
		this.store.set(this.keyPage, {});
	}
}
